/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumRichiestaModuloDTOStatoCompilazione =
  (typeof EnumRichiestaModuloDTOStatoCompilazione)[keyof typeof EnumRichiestaModuloDTOStatoCompilazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumRichiestaModuloDTOStatoCompilazione = {
  IN_COMPILAZIONE: 'IN_COMPILAZIONE',
  IN_FIRMA: 'IN_FIRMA',
  COMPLETATO: 'COMPLETATO',
} as const;
